import { Box, Flex, Text } from '@mantine/core'

import useTimeAgo from '@/hooks/useTimeAgo'
import { SocialMediaType, SocialsType } from '@/services/coin/social'

import SocialIcon from './SocialIcon'

export type Props = {
  username: string
  create_time: string
  type: SocialsType | SocialMediaType
}

export default function CardFooter(data: Props) {
  const { type, username } = data
  const displayDate = useTimeAgo(data.create_time)

  return (
    <Box p={16} pt={0} c="var(--text-secondary)">
      <Flex align="center">
        <SocialIcon type={type} fill="var(--text-secondary)" />
        <Text ml={4} variant="subtitle" fz={11} truncate>
          {username}
        </Text>
      </Flex>

      <Text fz={11} variant="subtitle" truncate>
        {displayDate}
      </Text>
    </Box>
  )
}
